import React from 'react'

export const DirectoryHydrateContext = React.createContext(false)
